import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#21a7ec",
      dark: "#1788c9",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#111111",
      contrastText: "#ffffff",
    },
    background: {
      default: "#f3f6f9",
      paper: "#ffffff",
    },
    text: {
      primary: "#111111",
      secondary: "#5c6570",
    },
  },
  typography: {
    fontFamily: '"Manrope", "Helvetica", "Arial", sans-serif',
    fontSize: 15,
    h1: { fontWeight: 800, letterSpacing: "-0.03em" },
    h2: { fontWeight: 800, letterSpacing: "-0.025em" },
    h3: { fontWeight: 700, letterSpacing: "-0.02em" },
    h4: { fontWeight: 700, letterSpacing: "-0.02em" },
    h5: { fontWeight: 700, letterSpacing: "-0.015em" },
    h6: { fontWeight: 700, letterSpacing: "-0.015em" },
    body1: { fontSize: "15px" },
    button: {
      textTransform: "none",
      fontWeight: 650,
    },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: 650,
          borderRadius: 10,
        },
        contained: {
          boxShadow: "none",
          "&:hover": { boxShadow: "none" },
        },
      },
    },
  },
});

export default theme;
